import _ from 'lodash';
import { Header } from 'components/slider/header';

import { ISlot, ISlotReview } from 'constants/types';

import { Routes } from 'constants/routes';
import { getItemIdentifier } from 'utils/slug';

import { SeeMore } from 'components/see-more';
import { Review } from 'components/table-reviews';
import styles from './styles.module.css';

export const Reviews = ({
  name,
  count,
  slot,
  userReviews,
  isSeeMoreVisible,
}: {
  name?: string;
  slot: ISlot;
  userReviews: ISlotReview[];
  isSlot?: boolean;
  count?: string | number;
  isSeeMoreVisible?: boolean;
}) => {
  if (!count) {
    return null;
  }

  const groupedByCasino: any = _.groupBy(
    userReviews,
    (item) => (item as any).casino?._id
  );

  return (
    <div className={styles.container_reviews}>
      <div className={styles.container_s}>
        {name && (
          <Header
            hasIcon
            name={name}
            count={count}
            url={Routes.slotRtpReviewsPage(getItemIdentifier(slot))}
          />
        )}

        <div className={styles.reviews__row}>
          {Object.entries(groupedByCasino).map(([casinoId, item]: any) => {
            return <Review key={casinoId} userReviews={item} />;
          })}
        </div>

        {isSeeMoreVisible && (
          <SeeMore
            description="Show all RTP reviews"
            url={Routes.slotRtpReviewsPage(getItemIdentifier(slot))}
          />
        )}
      </div>
    </div>
  );
};
